import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import CustomTagsField from 'js/components/CustomTagsField'
import GroupGuidField from 'js/components/EntityActions/Advanced/components/GroupGuidField'
import FormItem from 'js/components/Form/FormItem'
import Spacer from 'js/components/Spacer/Spacer'
import TagCategoriesField from 'js/components/TagCategories/TagCategoriesField'
import { useSubtypeOptions } from 'js/lib/hooks/useSubtypes'

import { buttonSubtypes, formSubtypes } from '../../helpers/supportedSubtypes'

interface Props {
    guid: string
    showGroupField: boolean
    site: {
        guid: string
        customTagsAllowed: boolean
        tagCategories: any
        entityFilter: any
    }
    groupGuid: string
    setGroupGuid: (value: string) => void
    categoryTagsValue: any
    setCategoryTagsValue: (value: string) => void
    customTags: string[]
    handleAddTags: (value: string) => void
    handleRemoveTags: (value: string) => void
}

const Content = ({
    guid,
    showGroupField,
    site,
    groupGuid,
    setGroupGuid,
    categoryTagsValue,
    setCategoryTagsValue,
    customTags,
    handleAddTags,
    handleRemoveTags,
}: Props) => {
    const { customTagsAllowed, tagCategories } = site

    const { t } = useTranslation()

    const { control, watch } = useFormContext()

    const watchLayout = watch('layout')

    const subtypes = watchLayout === 'button' ? buttonSubtypes : formSubtypes

    const subtypeOptions = useSubtypeOptions(subtypes, {
        includeCustomTypes: watchLayout === 'button',
    })

    return (
        <Spacer spacing="small">
            <FormItem
                control={control}
                type="select"
                name="subtype"
                id={`${guid}-subtype`}
                title={t('global.type')}
                description={t('widget-create-content.type-helper')}
                options={subtypeOptions}
                required
            />

            {showGroupField && (
                <GroupGuidField
                    value={groupGuid}
                    helper={t('widget-create-content.group-helper')}
                    onChange={setGroupGuid}
                />
            )}

            {watchLayout === 'form' && (
                <>
                    <TagCategoriesField
                        name="categoryTags"
                        label={t('form.tags')}
                        tagCategories={tagCategories}
                        value={categoryTagsValue}
                        setTags={setCategoryTagsValue}
                    />

                    {customTagsAllowed && (
                        <CustomTagsField
                            name="customTags"
                            value={customTags}
                            label={t('global.custom-tags')}
                            onAddTag={handleAddTags}
                            onRemoveTag={handleRemoveTags}
                        />
                    )}
                </>
            )}
        </Spacer>
    )
}

export default Content
